import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const OptionsContainer = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  top: 64px;
  left: 0;
  overflow: hidden;
  border: 1px solid ${Colors.GS500};
`
